import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import CartItems from '../Components/CartItems/CartItems'

const Cart = () => {
  const location = useLocation()

  // /checkout needs an account — send guests to login, then bring them back here.
  if (location.pathname === '/checkout' && !localStorage.getItem('auth-token')) {
    return <Navigate to="/login" replace state={{ from: '/checkout' }} />
  }

  return (
    <div>
      <CartItems/>
    </div>
  )
}

export default Cart
